import React from "react";
import { Chat as ChatIcon } from "@mui/icons-material";
import { Typography } from "@mui/material";
import chatBackground from "../../../assets/Chat/chat-bacground.svg";

const ChatWindow = ({ activeChat, children, onMouseDownDrag, isDarkMode = false }) => {
  if (!activeChat) {
    return (
      <div style={styles.welcomeScreen} onMouseDown={onMouseDownDrag}>
        <ChatIcon style={styles.welcomeIcon} />
        <Typography style={styles.welcomeTitle}>
         Ajustadores Web Chat
        </Typography>
        <Typography style={styles.welcomeSubtitle}>
          Selecciona un chat de la lista izquierda para comenzar a enviar y recibir mensajes.
        </Typography>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Capa del Patrón de Fondo SVG con Opacidad Ajustable e Inversión en Modo Oscuro */}
      <div
        style={{
          ...styles.bgPattern,
          filter: isDarkMode ? "invert(1)" : "none",
        }}
      />
      {/* Capa de Contenido por encima del fondo */}
      <div style={styles.content}>{children}</div>
    </div>
  );
};

const styles = {
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    flex: 1,
    backgroundColor: "var(--chat-bg-window, #ece5dd)", // <-- COLOR DE FONDO PRINCIPAL DEL CHAT
    overflow: "hidden",
  },
  bgPattern: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${chatBackground})`,
    backgroundRepeat: "repeat",
    backgroundSize: "700px", // <-- ESCALA DEL PATRÓN SVG
    opacity: "var(--chat-bg-pattern-opacity, 0.15)", // <-- CONTROL DE INTENSIDAD/COLOR DEL PATRÓN
    zIndex: 0,
    pointerEvents: "none",
  },
  content: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
  welcomeScreen: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    flex: 1,
    padding: "32px",
    textAlign: "center",
    backgroundColor: "var(--chat-bg-welcome, #f8f9fa)",
    userSelect: "none",
    cursor: "grab",
  },
  welcomeIcon: {
    fontSize: "80px",
    color: "#e1e7eb",
    marginBottom: "16px",
  },
  welcomeTitle: {
    fontSize: "20px",
    fontWeight: "300",
    color: "var(--chat-text-welcome-title, #41525d)",
    marginBottom: "8px",
    fontFamily: "Raleway, sans-serif",
  },
  welcomeSubtitle: {
    fontSize: "13px",
    color: "var(--chat-text-welcome-sub, #8696a0)",
    maxWidth: "320px",
    lineHeight: "1.5",
    fontFamily: "Raleway, sans-serif",
  },
};

export default ChatWindow;
